import { createContext } from "react";
import { DeviceDetailReducer } from ".";

type DeviceDetailContextType = DeviceDetailReducer & {
  dispatch: (action: Partial<DeviceDetailReducer>) => void;
};

export const DeviceDetailContext = createContext<DeviceDetailContextType>({
  toggleState: "live",
  calendarDate: new Date(),
  dispatch: () => {},
});
